module.exports = __webpack_public_path__ + "img/pexels-coffee.50792ae0.webp";